require('prism-themes/themes/prism-darcula.css');
require('prismjs/plugins/show-language/prism-show-language');
require('prismjs/plugins/line-highlight/prism-line-highlight.css');
require('prismjs/plugins/line-highlight/prism-line-highlight');
require('prismjs/plugins/line-numbers/prism-line-numbers.css');
